import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FileModel, UrlChange } from '@ca/core/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomValidators } from '../../../../utils/custom-validators/custom-validators';

@Component({
    selector: 'ca-add-or-edit-url-modal',
    templateUrl: './add-or-edit-url-modal.component.html',
    styleUrls: ['./add-or-edit-url-modal.component.scss'],
})
export class AddOrEditUrlModalComponent implements OnInit {
    @Input() url = '';
    @Input() urlMode: 'ADD' | 'EDIT' = 'ADD';
    @Input() selectedFiles: FileModel[] = [];
    @Input() maxFileSizeInBytes: number | undefined;
    @Input() maxFileSizeCustomMessage: string | undefined;
    @Input() supportedFileTypes: string[] | undefined;
    @Input() notSupportedFileTypeCustomMessage: string | undefined;

    formGroup: UntypedFormGroup;
    isSubmitting = false;

    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
    ) {}

    ngOnInit(): void {
        const selectedFilesWithoutCurrent = this.selectedFiles.filter(file => file.token !== this.url);
        this.formGroup = this.formBuilder.group({
            url: [
                this.url,
                [
                    Validators.required,
                    CustomValidators.HttpOrHttpsUrl(),
                    CustomValidators.decodeURIComponentAble(),
                    CustomValidators.NameDoesNotExistInFiles(selectedFilesWithoutCurrent),
                    CustomValidators.SupportedFileType(this.supportedFileTypes),
                ],
            ],
        });
    }

    submit(): void {
        this.isSubmitting = true;
        this.activeModal.close({ previousUrl: this.url, newUrl: this.formGroup.value.url } as UrlChange);
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }
}
